import Link from "next/link"
import Image from "next/image";
import Grid from "@mui/material/Grid";
import { getCanonicalSlug, productLink } from "@components/config/helpers";


const ProductVariantImageContainer = (props) => {
    const {
        idx,
        product = false,
        variant,
        package_core,
        long_term,
        source = null,
    } = props;

    const imageProps = {
        src: !product ? variant.image : variant.cart_image,
        alt: !product ? variant.product_name : variant.product_variant_label,
        title: !product ? variant.product_name : `${variant.product_code} - ${variant.product_variant_label}`
    };

    const urlLink = getCanonicalSlug({canonical_category_slug: variant.canonical_category_slug, section_slug: variant.section_slug});

    return (
        <Grid 
            container  
            direction={'row'} 
            className={`${source == 'search' ? 'd-none' : 'd-block'} w-fit`} 
            key={idx}
        >
            <Grid 
                item xs={12} 
                className={`mr-1 ${!product || (product && product?.product_id !== variant.product_variant_product_id)  &&  'hover-underline'}`} 
                sx={{ 
                    border: (!product ) || (product && product?.product_id === variant.product_variant_product_id)  ? '2px solid var(--color-primary)' : 'unset'
                }}  
            >
                <Link shallow={true} className={`d-flex ${package_core && 'pointerEvent'}`}  href={productLink(urlLink, variant.product_slug, long_term)}>
                    <Image
                        loading="lazy"
                        priority={false}
                        width={50}
                        height={50}
                        src={imageProps.src} 
                        alt={imageProps.alt} 
                        title={imageProps.title} 
                        quality={75}  
                    />
                </Link>
            </Grid>
        </Grid>
    )
}

export default ProductVariantImageContainer